import { useEffect } from "react";
import { Flex, Paper, Header3, PrimaryButton, IconButton } from "@base-ui";
import selectableIcons from "constants/icons/selectableIcons";
import { closePopup, blockDefaultEvent } from "utils/events";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function IconPopup(props) {
  var selectIcon = props.selectIcon;
  useEffect(function () {
    document.getElementById("select-icon-0").focus();
  }, []);
  var handleCancel = function handleCancel(e) {
    blockDefaultEvent(e);
    closePopup();
  };
  var handleConfirmIcon = function handleConfirmIcon(icon) {
    closePopup();
    selectIcon(icon);
  };
  var iconsMarkup = selectableIcons.map(function (icon, idx) {
    return /*#__PURE__*/_jsx(IconButton, {
      id: "select-icon-".concat(idx),
      className: "select-icon",
      label: "V\xE4lj ".concat(icon.src),
      icon: "".concat(icon.src, "_lg"),
      iconSize: "md",
      width: "90px",
      height: "85px",
      onClick: function onClick() {
        return handleConfirmIcon(icon);
      }
    }, icon.src);
  });
  return /*#__PURE__*/_jsxs(Paper.Column, {
    width: "520px",
    children: [/*#__PURE__*/_jsx(Header3, {
      inverted: true,
      m: "0",
      p: "15px 20px",
      backgroundColor: "P3",
      children: "V\xE4lj en ikon"
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      p: "sm",
      children: [/*#__PURE__*/_jsx(Flex.Row, {
        flexWrap: "wrap",
        height: "350px",
        mb: "10px",
        overflowY: "auto",
        children: iconsMarkup
      }), /*#__PURE__*/_jsx(Flex.Row, {
        justifyContent: "flex-end",
        children: /*#__PURE__*/_jsx(PrimaryButton, {
          id: "leave-popup",
          width: "130px",
          onClick: handleCancel,
          children: "Avbryt"
        })
      })]
    })]
  });
}